import { render, staticRenderFns } from "./Saler.vue?vue&type=template&id=6a032dcc"
import script from "./Saler.vue?vue&type=script&lang=js"
export * from "./Saler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports